module.exports = __webpack_public_path__ + "img/chr_ts_90_25_2.f756d99d.png";